module.exports = __webpack_public_path__ + "static/oomfo-220b71e1c5f02624ca6a0312ba18fc16.svg";